import axios from "axios";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import VanillaOTP from "./classes/VanillaOTP";
import { Preferences } from "@capacitor/preferences";
import { App } from "@capacitor/app";
import { app } from "modular-openscriptjs";


window.isLoggedIn = window.isLoggedIn ?? false;
window.currentUser = window.currentUser ?? {};
window.requiredOtp = window.requiredOtp ?? false;
window.verifiedOtp = window.verifiedOtp ?? false;
window.baseUrl = window.baseUrl ?? "";

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.VanillaOTP = VanillaOTP;
window.Pusher = Pusher; 

window.Echo = new Echo({
    broadcaster: "reverb",
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? "https") === "https",
    enabledTransports: ["ws", "wss"],

    channelAuthorization: {
        customHandler: (params, callback) => {
            (async () => {
                const token = await Preferences.get({ key: "auth_token" });

                if(!token) {
                    callback(true, { message: "Unauthorized" });
                    return;
                }

                axios
                    .post(
                        (import.meta.env.VITE_API_BASE_URL ?? "") +
                            "/broadcasting/auth",
                        {
                            socket_id: params.socketId,
                            channel_name: params.channelName,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${token.value}`,
                                Accept: "application/json",
                            },
                        },
                    )
                    .then((response) => {
                        callback(false, response.data);
                    })
                    .catch((error) => {
                        callback(true, error);
                    });
            })();
        },
    },
});

App.addListener("appUrlOpen", function (event) {
    const url = event.url;

    if (url.startsWith("https://rider.carata.co")) {
        const path = new URL(url).pathname;
        app("router").to(path);
    }
});

App.addListener("appStateChange", (state) => {
	if (state.isActive) {
		app("gc").appInForeground.value = true;
	} else {
		app("gc").appInForeground.value = false;
	}
});


import "./declarations";
import "./global-config";
import "./firebase";
import "./mediators";
import "./ojs.routes";
import "./boot";